import React from 'react';
import { LayoutGap, SelectionType, Type } from '@philips-internal/oswald-ui-constants';
import { Card } from '../../card/card.js';
import { Deck } from '../../deck/deck.js';
import { Mapper } from '../../mapper/mapper.js';
import { filterNotificationItems, mapNotificationItems, sortNotificationItems } from '../utils.js';
import { NotificationCenterItem } from './notification-center-item.js';
import './notification-center-groups.css';
const GROUPS_MAPPER = {
    message: 'description',
    title: 'title',
};
const SUPERSCRIPTION_VALUES = [
    { color: 'safety-yellow', label: '', value: Type.CAUTION },
    { color: 'safety-red', label: '', value: Type.DANGER },
    { color: 'signal-gray-30', label: '', value: Type.NEUTRAL },
    { color: 'safety-blue', label: '', value: Type.NOTICE },
    { color: 'safety-green', label: '', value: Type.SAFETY },
    { color: 'safety-orange', label: '', value: Type.WARNING },
];
function NotificationCenterGroups(props) {
    const { canDeleteNotification, canMarkAsRead, canMarkAsUnread, data = [], firstPage, limit, onItemClick, uuid, ...otherProps } = props;
    const items = mapNotificationItems(sortNotificationItems(filterNotificationItems(data)));
    return (React.createElement("div", { className: "c-notification-center-groups" },
        React.createElement(Mapper, { data: items, map: GROUPS_MAPPER },
            React.createElement(Deck, { ...otherProps, collapsible: true, data: items, firstPage: firstPage, groupBy: "date", groupGap: LayoutGap.XSMALL, limit: limit, loading: false, rowGap: LayoutGap.NONE, uuid: `notification-center-deck-${uuid}` },
                React.createElement(Card, { selectionType: SelectionType.SINGLE, superscription: SUPERSCRIPTION_VALUES, superscriptionEntry: "type", transparent: false, uuid: `notification-center-card-${uuid}`, width: 12 },
                    React.createElement(NotificationCenterItem, { canDeleteNotification: canDeleteNotification, canMarkAsRead: canMarkAsRead, canMarkAsUnread: canMarkAsUnread, onItemClick: onItemClick, uuid: `notification-center-item-${uuid}` }))))));
}
export { NotificationCenterGroups, };
//# sourceMappingURL=notification-center-groups.js.map